module.exports = __webpack_public_path__ + "img/blockchain_xl.8ae6727c.png";